import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from '@/router/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "./config/rem";

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI)
document.title = "Hit Fortune"

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
